import {Component, Prop, Vue} from 'vue-property-decorator';
import { convertDateToCustomFormat } from '@/util/date-util';
import { UserPlan } from '@/shared/model/account.model';
import { getFreeTrialOrPaid, getSpecificRoleUser } from '@/util/paid-user-util';
import moment from 'moment';

@Component({
  computed: {
    moment() {
      return moment;
    },
  },
  methods: { getSpecificRoleUser, convertDateToCustomFormat },
  components: {},
})
export default class UserPaidInfo extends Vue {
  @Prop(Boolean) readonly isGuest;

  localStorageUser = JSON.parse(localStorage.getItem('localStorageUser')) || null;
  currentPlan = new UserPlan();

  goTo(destination: string) {
    this.$router.push(destination);
  }

  mounted() {
    this.currentPlan = getFreeTrialOrPaid();
  }
}
